import { EpRadioGroup } from '../../../../components/EpRadioGroup';
import { useFormContext, useWatch } from 'react-hook-form';
import { EpErrorMessage, EpRadioButton } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';

const SignalingSocialMediaByFamily = ({
  translations,
}: {
  translations: unknown;
}) => {
  const [thereWasNegativeDemonstration, patientOrFamilyKnow] = useWatch({
    name: ['thereWasNegativeDemonstration', 'patientOrFamilyKnow'],
  });

  const controller = 'witnessSignalingLegalCompanySocialMediaByFamily';
  const { formState: { errors } } = useFormContext();

  if (
    thereWasNegativeDemonstration &&
    thereWasNegativeDemonstration.inputValue &&
    thereWasNegativeDemonstration.inputValue === 'true' &&
    patientOrFamilyKnow.inputValue &&
    patientOrFamilyKnow.inputValue === 'true'
  ) {
    return (
      <>
        <EpRadioGroup
          legend={t(
            translations,
            'Did you witness the signaling of juridical, press or social media activity by the family?',
          )}
        >
          <EpRadioButton
            radioId={`EpRadio__yes`}
            radioValue={'true'}
            radioName={controller}
            radioLabel={t(translations, 'Yes')}
            required={true}
            errorMessage={t(translations, '* Required Fied')}
            radioWithError={!!errors[controller]}
          />

          <EpRadioButton
            radioId={`EpRadio__no`}
            radioValue={'false'}
            radioName={controller}
            radioLabel={t(translations, 'No')}
            required={true}
            errorMessage={t(translations, '* Required Fied')}
            radioWithError={!!errors[controller]}
          />
        </EpRadioGroup>
        <EpErrorMessage
          inputName={controller}
        />
      </>
    );
  }

  return null;
};

export default SignalingSocialMediaByFamily;
